(function () {
  function buildFAQSchemaFromDOM(root) {
    var items = root.querySelectorAll('details.blog-faq__item');
    var entities = [];

    for (var i = 0; i < items.length; i++) {
      var summary = items[i].querySelector('summary');
      var answer = items[i].querySelector('.blog-faq__answer');
      if (!summary || !answer) continue;

      // Clone summary so we can remove the icon before reading text
      var q = summary.cloneNode(true);
      var icon = q.querySelector('.blog-faq__icon');
      if (icon) icon.remove();

      var questionText = (q.textContent || '').replace(/\s+/g, ' ').trim();
      var answerText = (answer.textContent || '').replace(/\s+/g, ' ').trim();

      if (!questionText || !answerText) continue;

      entities.push({
        "@type": "Question",
        "name": questionText,
        "acceptedAnswer": { "@type": "Answer", "text": answerText }
      });
    }

    if (!entities.length) return;

    // Prevent duplicates if multiple accordions exist
    if (document.getElementById('auto-faq-schema')) return;

    var script = document.createElement('script');
    script.type = 'application/ld+json';
    script.id = 'auto-faq-schema';
    script.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": entities
    });
    document.head.appendChild(script);
  }

  function initFAQAccordions() {
    var wraps = document.querySelectorAll('[data-faq-accordion]');
    for (var w = 0; w < wraps.length; w++) {
      (function (wrap) {
        // Accordion behavior: only one open at a time within this wrap
        wrap.addEventListener('toggle', function (e) {
          var target = e.target;
          if (!target || target.tagName !== 'DETAILS' || !target.open) return;

          var openItems = wrap.querySelectorAll('details[open]');
          for (var i = 0; i < openItems.length; i++) {
            if (openItems[i] !== target) openItems[i].removeAttribute('open');
          }
        }, true);

        // Auto-generate FAQ schema if requested
        if (wrap.hasAttribute('data-faq-schema')) {
          buildFAQSchemaFromDOM(wrap);
        }
      })(wraps[w]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFAQAccordions);
  } else {
    initFAQAccordions();
  }
})();
